@use "../zr-theme/zr-variables.scss" as *;
@use "../zr-theme/functions/fonts" as f;

// local component name
$component: 'zr-rating';

:host {
    display: block;
    margin-top: 16px;

    &:first-child {
        margin-top: 0;
    }
}

.#{$component}__diagram {
    display: flex;
    gap: 8px;
    align-items: center;
}

.#{$component}__diagram-level {
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    font-size: f.calc-em(16);
    text-align: center;
    color: var(--ci-neutral900);
}

.#{$component}__diagram-meter {
    width: 100%;
    background-image: none;
    background-color: var(--ci-neutral200);
    border-color: transparent;

    &,
    &::-webkit-meter-bar {
        height:16px;
    }

    &::-webkit-meter-bar,
    &::-webkit-meter-optimum-value {
        border: none;
        border-radius: 2px;
    }

    &::-webkit-meter-bar {
        background-image: none;
        background-color: var(--ci-neutral200);
    }

    &::-webkit-meter-optimum-value {
        border-radius: 2px;
        background-color: var(--ci-primary400);
        background-image: none;
    }

    &:-moz-meter-optimum::-moz-meter-bar {
        background: var(--ci-primary400);
    }
}

.#{$component}__diagram-meter-label {
    font-family: 'Open Sans', sans-serif;
    font-weight: 300;
    font-size: f.calc-em(14);
    text-align: right;
    min-width: 34px;
}
